/* Aktionsleiste: Banner oben fixieren, Timer mit echter Frist einsetzen.
   Modus cutoff   = taeglicher Versandschluss, eine wiederkehrende echte Frist.
   Modus deadline = fester Endzeitpunkt; ist er vorbei, verschwindet der Timer.
   Der Timer startet bewusst nicht bei jedem Besuch neu. */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function naechsterVersandschluss(hh, mm, nurWerktage) {
    var jetzt = new Date();
    var z = new Date(jetzt);
    z.setHours(hh, mm, 0, 0);
    var heute = z > jetzt;
    if (!heute) { z.setDate(z.getDate() + 1); }
    if (nurWerktage) {
      while (z.getDay() === 0 || z.getDay() === 6) { z.setDate(z.getDate() + 1); heute = false; }
    }
    return { ziel: z, heute: heute };
  }

  function formatiere(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var tage = Math.floor(s / 86400);
    var std = Math.floor((s % 86400) / 3600);
    var min = Math.floor((s % 3600) / 60);
    var sek = s % 60;
    if (tage > 0) return tage + (tage === 1 ? ' Tag ' : ' Tage ') + std + ' Std';
    if (std > 0) return std + ' Std ' + pad(min) + ' Min';
    return min + ' Min ' + pad(sek) + ' Sek';
  }

  function init() {
    var cfg = document.querySelector('[data-ee-bar]');
    if (!cfg) return;
    var bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.eeReady) return;
    bar.dataset.eeReady = '1';

    /* Hoehe der Leiste laufend an den Header weitergeben.
       Achtung: bei position fixed ist offsetParent immer null, deshalb wird
       ueber display und die gemessene Hoehe geprueft. */
    function sichtbar(el) {
      var cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
    }
    var letzteHoehe = -1;
    function messen() {
      var h = sichtbar(bar) ? Math.round(bar.getBoundingClientRect().height) : 0;
      if (h !== letzteHoehe) {
        document.documentElement.style.setProperty('--ee-bar-h', h + 'px');
        letzteHoehe = h;
      }
    }
    messen();
    addEventListener('resize', messen);
    addEventListener('load', messen);
    if ('ResizeObserver' in window) { new ResizeObserver(messen).observe(bar); }
    var schliessen = bar.querySelector('.close');
    if (schliessen) { schliessen.addEventListener('click', function () { setTimeout(messen, 60); setTimeout(messen, 400); }); }
    setTimeout(messen, 800);
    setTimeout(messen, 2500);

    if (cfg.getAttribute('data-timer') !== 'an') return;

    var modus = cfg.getAttribute('data-mode') || 'cutoff';
    var zeit = (cfg.getAttribute('data-cutoff') || '14:00').split(':');
    var hh = parseInt(zeit[0], 10) || 0, mm = parseInt(zeit[1], 10) || 0;
    var nurWerktage = cfg.getAttribute('data-werktage') === 'an';
    var textVor = cfg.getAttribute('data-vor') || '';
    var textZu = cfg.getAttribute('data-zu') || '';
    var frist = cfg.getAttribute('data-deadline') || '';

    var el = document.createElement('span');
    el.className = 'ee-timer';
    el.setAttribute('role', 'timer');
    el.innerHTML = '<span class="ee-timer__dot" aria-hidden="true"></span><span class="ee-timer__text"></span>';
    var textEl = el.querySelector('.ee-timer__text');
    var letzter = '';

    function zielZeit() {
      if (modus === 'deadline') {
        if (!frist) return null;
        var d = new Date(frist.replace(' ', 'T'));
        return isNaN(d.getTime()) ? null : { ziel: d, heute: true };
      }
      return naechsterVersandschluss(hh, mm, nurWerktage);
    }

    function weg() { if (el.parentNode) { el.parentNode.removeChild(el); messen(); } }

    function tick() {
      var z = zielZeit();
      if (!z) { weg(); return; }
      var rest = z.ziel.getTime() - Date.now();

      if (modus === 'deadline' && rest <= 0) { weg(); return; }

      if (modus === 'cutoff' && !z.heute) {
        if (!textZu) { weg(); return; }
        if (letzter !== textZu) { textEl.textContent = textZu; letzter = textZu; messen(); }
        setTimeout(tick, 60000);
        return;
      }

      var zahl = formatiere(rest);
      var neu = textVor + '|' + zahl;
      if (neu !== letzter) {
        textEl.textContent = '';
        if (textVor) { textEl.appendChild(document.createTextNode(textVor + ' ')); }
        var num = document.createElement('span');
        num.className = 'ee-timer__num';
        num.textContent = zahl;
        textEl.appendChild(num);
        letzter = neu;
        messen();
      }
      setTimeout(tick, rest < 3600000 ? 1000 : 20000);
    }

    var p = bar.querySelector('p');
    if (p && p.parentNode === bar) { bar.insertBefore(el, p.nextSibling); } else { bar.appendChild(el); }
    tick();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
